import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import VacationInformationButton from './vacation-information-button';

export class SaveVacationOptions extends React.Component {

  static propTypes = {
    userData: PropTypes.object.isRequired,
    callback: PropTypes.func.isRequired,
    hideTitle: PropTypes.bool,
    reverseButtonOrder: PropTypes.bool
  };

  constructor (props) {
    super(props);

    this.state = {
    };

    this.changeSaveVacation = this.changeSaveVacation.bind(this);
  }

  changeSaveVacation (event) {
    const saveVacation = parseInt(event.target.value);
    this.setState({
      saveVacation: saveVacation
    });

    this.props.callback(
      'saveVacationPay',
      {
        value: !!saveVacation,
        valid: true
      }
    );
  }

  renderTitle () {
    if (this.props.hideTitle) {
      return null;
    }

    return (<div>
      <Translate
        className='invoicing-vacation-title'
        content='VACATION_PAY'
      />
      <VacationInformationButton />
    </div>);
  }

  render () {
    const firstAlternativeValue = this.props.reverseButtonOrder ? 1 : 0;
    const secondAlternativeValue = this.props.reverseButtonOrder ? 0 : 1;
    const firstAlternativeText = this.props.reverseButtonOrder
      ? <span>
        {proxyCounterpart('COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SAVE_VACATION')}
        <VacationInformationButton />
      </span>
      : <span>{proxyCounterpart('COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_PAY_VACATION')}</span>;
    const secondAlternativeText = this.props.reverseButtonOrder
      ? <span>{proxyCounterpart('MODAL_SAVE_VACATION_INVOICING_INFO_CONTINUE_AS_IT_IS')}</span>
      : <span>{proxyCounterpart('COMPLETE_INFORMATION_ORDER_TOOL_INVOICING_INFO_SAVE_VACATION')} *</span>;

    return (
      <div className='input-row-column'>
        {this.renderTitle()}
        <span className='invoicing-vacation-option'>
          <input
            id='save-vacation-alt-false'
            type='radio'
            name='save-vacation'
            value={firstAlternativeValue}
            checked={this.state.saveVacation === firstAlternativeValue}
            onChange={this.changeSaveVacation}
          />
          <label htmlFor='save-vacation-alt-false'>
            <span></span>
            {firstAlternativeText}
          </label>
        </span>
        <span className='invoicing-vacation-option'>
          <input
            id='save-vacation-alt-true'
            type='radio'
            name='save-vacation'
            value={secondAlternativeValue}
            checked={this.state.saveVacation === secondAlternativeValue}
            onChange={this.changeSaveVacation}
          />
          <label htmlFor='save-vacation-alt-true'>
            <span></span>
            {secondAlternativeText}
          </label>
        </span>
      </div>);
  }
}

export default SaveVacationOptions;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/complete-information-modal/save-vacation-options.js
 **/